import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Radio,
  RadioGroup,
  Spinner,
  Stack,
  Text,
} from "@chakra-ui/react";
import { usePassportFormState, usePassportFormStateReaction, } from "./hooks";
import {
  EPassportFormState,
  PASSPORT_FOREIGN,
  PASSPORT_RF,
  TRadioOption,
} from "../../../../store/slices/passportFormSliceCreator.ts";
import { SyntheticEvent, useEffect, useMemo, useRef, } from "react";
import { useMaskito, } from "@maskito/react";
import { MaskitoMask, } from "@maskito/core";

const MASKS_MAP = {
  PASSPORT_RF: {
    mask: [/\d/, /\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/, /\d/, /\d/, /\d/,] as MaskitoMask,
    placeholder: "Серия и номер паспорта",
  },
  PASSPORT_FOREIGN: {
    mask: Array(15,).fill(/[A-Z0-9]/,) as MaskitoMask,
    placeholder: "Номер документа",
  },
} as const;

export function PassportForm() {
  const passportForm = usePassportFormState();
  usePassportFormStateReaction();

  const currentMask = useMemo(() => {
    return passportForm.passportType
      ? MASKS_MAP[passportForm.passportType]
      : MASKS_MAP.PASSPORT_RF;
  }, [passportForm.passportType,],);

  const inputRef = useMaskito({
    options: { mask: currentMask.mask, },
  },);
  const domRef = useRef<HTMLInputElement | null>(null,);

  const setRef = (el: HTMLInputElement | null,) => {
    inputRef(el,);
    domRef.current = el;
  };

  const handleSubmit = (): void => {
    if (passportForm.formState === EPassportFormState.initial) {
      passportForm.setFormState(EPassportFormState.validating,);
    }
  };

  const onTextChange = (e: SyntheticEvent<HTMLInputElement>,) => {
    passportForm.setPassportNumber(e.currentTarget.value,);
    passportForm.setTextError("",);
  };

  const onRadioChange = (e: TRadioOption,) => {
    passportForm.setPassportType(e,);
  };

  useEffect(() => {
    if (domRef.current) {
      domRef.current.value = "";
    }
    passportForm.setPassportNumber("",);
    passportForm.setTextError("",);
  }, [passportForm.passportType,],);

  return (
    <Stack spacing={4}>
      <FormControl isInvalid={!!passportForm.errorMessageOption}>
        <FormLabel>Паспортные данные</FormLabel>
        <RadioGroup
          onChange={onRadioChange}
          value={passportForm.passportType ?? undefined}
        >
          <Stack direction="row" spacing={3}>
            <Radio value={PASSPORT_RF} colorScheme="brand">
              <Text fontSize={14}>Паспорт РФ</Text>
            </Radio>
            <Radio value={PASSPORT_FOREIGN} colorScheme="brand">
              <Text fontSize={14}>Иностранный паспорт</Text>
            </Radio>
          </Stack>
        </RadioGroup>
        <FormErrorMessage>{passportForm.errorMessageOption}</FormErrorMessage>
      </FormControl>
      <FormControl isInvalid={!!passportForm.errorMessageText}>
        <Input
          key={passportForm.passportType ?? PASSPORT_RF}
          ref={setRef}
          name="passport-number"
          defaultValue={passportForm.passportNumber}
          onInput={onTextChange}
          placeholder={currentMask.placeholder}
        />
        <FormErrorMessage>{passportForm.errorMessageText}</FormErrorMessage>
      </FormControl>

      {/* Кнопка */}
      <Button
        colorScheme="brand"
        onClick={handleSubmit}
        isDisabled={passportForm.formState === EPassportFormState.submitting}
      >
        {passportForm.formState === EPassportFormState.initial
          ? "Продолжить"
          : (
            <Spinner
              thickness="2px"
              speed="0.65s"
              emptyColor="gray.200"
              color="white"
            />
            )}
      </Button>
    </Stack>
  );
}
